module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/070-tuvalu-1-76a5a301dc6d3a1f86d19284a3b49a24.svg";